import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import BlockyDatePicker from 'generic/BlockyDatePicker/BlockyDatePicker.react';

const hasError = (startDate, endDate) => {
  const now = moment()
    .endOf('day')
    .valueOf();
  const yearAfterStartDate = moment(startDate).add(1, 'years');
  const isBefore = moment(endDate).isBefore(yearAfterStartDate);

  if (startDate === 'initial' || endDate === 'initial') {
    return false;
  }
  if (startDate && endDate && startDate <= now && endDate <= now && isBefore) {
    const isValid = moment(startDate)
      .startOf('day')
      .isBefore(moment(endDate).endOf('day'));
    return !isValid;
  }
  return true;
};

const errorMessage = (startDate, endDate) => {
  const now = moment()
    .endOf('day')
    .valueOf();
  const yearAfterStartDate = moment(startDate).add(1, 'years');
  const isBefore = moment(endDate).isBefore(yearAfterStartDate);
  if (startDate !== 'initial' && endDate !== 'initial') {
    if (startDate > now || endDate > now) {
      return 'Please enter valid start and end dates.';
    }
    if (
      !moment(startDate)
        .startOf('day')
        .isBefore(moment(endDate).endOf('day'))
    ) {
      return 'Please enter a valid date range';
    }
    if (!isBefore) {
      return 'Please enter a date range under a year.';
    }
  }
};

const AuthorDashboardMetricsCustomDate = ({
  storeCustomStartDate,
  storeCustomEndDate,
  startDate,
  endDate
}) => {
  const error = hasError(startDate, endDate);
  const errorDiv = hasError ? <div>{errorMessage(startDate, endDate)}</div> : null;
  return (
    <div className='author-dashboard-metrics__custom-container'>
      <div className='author-dashboard-metrics__custom-dropdown-container'>
        <BlockyDatePicker
          className='author-dashboard-metrics__custom-dropdown u-mar-r_1'
          error={error}
          name='startDate'
          onChange={(e) => {
            if (e.target.value) {
              storeCustomStartDate(
                moment(e.target.value)
                  .startOf('day')
                  .valueOf()
              );
            }
          }}
        />
        <BlockyDatePicker
          className='author-dashboard-metrics__custom-dropdown'
          error={error}
          name='endDate'
          onChange={(e) => {
            if (e.target.value) {
              storeCustomEndDate(
                moment(e.target.value)
                  .endOf('day')
                  .valueOf()
              );
            }
          }}
        />
      </div>
      <div className='author-dashboard-metrics__custom-error'>{errorDiv}</div>
    </div>
  );
};

AuthorDashboardMetricsCustomDate.propTypes = {
  storeCustomStartDate: PropTypes.func,
  storeCustomEndDate: PropTypes.func,
  startDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  endDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default AuthorDashboardMetricsCustomDate;
